import { Model } from 'modules/core/lib/mobx-rest'

interface IIncidenceMessage {
  id: number
  message: string
  sender_id?: number
  sender_name?: string
  sender_avatar?: string
  incidence_id?: number
  created_at: string
}

class IncidenceMessage extends Model<IIncidenceMessage> {
  static urlRoot() {
    return '/bookkeepers_management/incidence_messages'
  }
}

export default IncidenceMessage
